import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Divider, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, InputLabel, Radio, RadioGroup, Switch, TextField, Typography } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SearchableDropdown from '../../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { BLOCKED_EXTENSIONS, CategoryOptions, HeaderOptions, LanguageList, WHATSAPP_ALLOWED_MIME, WHATSAPP_LIMITS } from '../../Template/template.constant.js';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { alertAtom, channelListAtom, organisationFilterAtom, organisationResponseAtom, TempFormButtonsAtom, TempFormErrorsAtom, templateTableStateAtom, userInformationAtom, WhatsAppTempFormAtom } from '../../../../Services/_states/index.js';
import EditIcon from '@mui/icons-material/Edit';
import OrganisationBotSelectionModal from '../../../Modals/OrganisationBotSelectionModal/index.tsx';
import FileInput from '../../../Shared/FileUploadPreview/FileInput.jsx';
import { useNavigate, useParams } from 'react-router';
import CloseIcon from '@mui/icons-material/Close';
import { ConstantActions, FlowBuilderActions, TemplateActions } from '../../../../Services/_actions/index.js';
import { useSnackBar } from '../../../FlowBuilder/Common/SnackBar/index.tsx';
import LoadingButton from '../../../Shared/Loading/index.tsx';
// import ButtonInputs from '../../Template/ButtonInputs.tsx';
import MessagePreview from '../Summary/MessagePreview.tsx';
import ButtonInputs from './ButtonInputs.tsx';
import { BackButton } from '../../../Shared/BackButton/index.jsx'; 
import ErrorWrapper from '../../../Shared/ErrorWrapper/index.jsx';

function CreateTemplates() {
  const actions = TemplateActions();
  const [formData, setFormData] = useRecoilState(WhatsAppTempFormAtom);
  const [isEditMode, setIsEditMode] = useState(false);
  const [filterObj, setFilterObj] = useState({ botNumber: '' });
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModeModal, setIsEditModeModal] = useState(false);
  const [editIconEnable, setEditIconEnable] = useState(false);
  const [formErrors, setFormErrors] = useRecoilState(TempFormErrorsAtom);
  const [file, setFile] = useState(null);
  const { templateName, botNumber } = useParams();
  const textareaRef = useRef(null);
  const onFileRemove = (e) => setFile(null);
  const resetTableState = useResetRecoilState(templateTableStateAtom)
  const navigate = useNavigate();
  const { showSnackBar } = useSnackBar();
  const [loading, setLoading] = useRecoilState(alertAtom);
  const [channelList, setChannelList] = useRecoilState(channelListAtom);
  const [buttonArrayObj, setButtonArrayObj] = useRecoilState(TempFormButtonsAtom);
  const [keyStakeholders, setKeyStakeholders] = useState([]);
  const [keyStakeholderOptions, setKeyStakeholderOptions] = useState([]);
  const [organisationRes, setOrganisationRes] = useRecoilState(organisationResponseAtom);
  const [organisationFilter, setOrganisationFilter] = useRecoilState(organisationFilterAtom);
  const flowBuilderActions = FlowBuilderActions();
  const constantActions = ConstantActions();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const navigation = useNavigate();
const resetButtons = useResetRecoilState(TempFormButtonsAtom);
const resetForm = useResetRecoilState(WhatsAppTempFormAtom);
const resetErrors = useResetRecoilState(TempFormErrorsAtom);

  const handleCloseModal = (data) => {
    if (data) {
      setModalOpen(false);
      setFilterObj({ ...filterObj, botNumber: data?.botNumber?.wa_phone_number, organisation: data?.organisation?.organisation_id, organisationObj: data?.organisation, botNumberObj: data?.botNumber });
      // fetchKeyStakeholders(data?.organisation?.organisation_id);
    } else if (isEditModeModal) {
      setModalOpen(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData?.name) errors.name = 'Template name is required';
    if (!formData?.language) errors.language = 'Language is required';
    let bodyObj = formData?.components?.find((component) => component?.type === 'BODY');

    if (!bodyObj?.text)
      errors[`body`] = `This field is required`

    bodyObj?.example?.body_text[0]?.forEach((item, index) => {
      if (!item)
        errors[`bodyVariable_${index}`] = `This field is required`;
    })
    if (formData?.param) {
      formData?.param?.forEach((item, index) => {
        if (!item)
          errors[`bodyParams_${index}`] = `This field is required`;
      })
    }
    let headerObj = formData?.components?.find((component) => component?.type === 'HEADER');
    if (headerObj && headerObj?.format === "TEXT" && !headerObj?.text)
      errors['headerText'] = "This field is required";

    if (buttonArrayObj?.callAction && buttonArrayObj?.callAction.length > 0) {
      buttonArrayObj?.callAction?.forEach((btn, index) => {
        if (btn?.type === 'URL') {
          if (!btn.text) errors[`callActionBtn_text_${index}`] = `This field is required ${index + 1}`;
          if (!btn.url) errors[`callActionBtn_url_${index}`] = `This field is required ${index + 1}`;
        } else if (btn?.type === 'PHONE_NUMBER') {
          if (!btn.phone_number) errors[`callActionBtn_phone_number_${index}`] = `Valid phone number is required ${index + 1}`;
          if (!btn.text) errors[`callActionBtn_text_${index}`] = `This field is required ${index + 1}`;
        } else if (btn?.type === 'OFFER_CODE') {
          if (!btn.text) errors[`callActionBtn_text_${index}`] = `This field is required ${index + 1}`;
          // if (!btn.url) errors[`callActionBtn_url_${index}`] = `This field is required ${index + 1}`;
        }
      });
    }
    if (buttonArrayObj?.quickReply && buttonArrayObj?.quickReply.length > 0) {
      buttonArrayObj?.quickReply?.forEach((btn, index) => {
        if (!btn?.text) errors[`quickReplyBtn_${index}`] = `This field is required ${index + 1}`;
      });
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const getTemplateData = async () => {
    let res = await actions.getTemplateByNameAndBotNumber(templateName, botNumber)
    if (res?.status === 200) {
      setFormData(res?.data);
      setFilterObj({ ...filterObj, botNumber: res?.data?.bot_number, botNumberObj: { app_name: res?.data?.app_name || '', wa_phone_number: res?.data?.bot_number } });

      // let objData = channelList.find(obj => obj.channel_number === res?.data?.bot_number);
      // handleSelectBot(objData);
    }
  }

  const handleChangeName = (e) => {
    const convertedText = e?.target?.value?.replace(/ /g, '_').toLowerCase();;
    setFormData({ ...formData, name: convertedText || '' });
  };

  const handleChangeDescription = (e) => {
    setFormData({ ...formData, description: e.target.value });
  };

  const fetchChannels = async (organisation) => {
    setChannelList([]);
    try {
      let res = await flowBuilderActions.whatsappBusinessAccounts(organisation?.organisation_id);
      if (res?.status === 200) {
        setChannelList(res?.data || []);
        if (res?.data?.length === 1) {
          setEditIconEnable(true);
          setFilterObj({ ...filterObj, botNumber: res?.data[0]?.wa_phone_number, botNumberObj: res?.data[0] });
        } else if (res?.data?.length === 0) {
          setFilterObj({ ...filterObj, organisation: organisation, botNumber: "", botNumberObj: null });
          showSnackBar('Bot number is not available for this organisation:', 'error');
        } else {
          setModalOpen(true);
          setFilterObj({ ...filterObj, organisation: organisation, botNumberObj: null, botNumber: "" });
        }
      } else {
        showSnackBar('Unexpected response structure or status:', 'error');
      }
    } catch (error) {
      showSnackBar(error?.toString(), 'error');
    }
  };

  const fetchOrganisations = async (filterObj) => {
    if (!loggedInUser?.is_superuser) {
      fetchChannels(loggedInUser?.profile?.organisation);
      return;
    }
    try {
      const res = await constantActions.getOrganisationsWithPagination(filterObj);
      if (res?.status === 200 && res?.data) {
        setOrganisationFilter({ ...organisationFilter, page: organisationFilter.page + 1 });
        setOrganisationRes(res?.data);
        if (res?.data?.list?.length === 1) {
          setFilterObj({ ...filterObj, botNumber: "", organisation: res?.data?.list[0]?.organisation_id, organisationObj: res?.data?.list[0], botNumberObj: null });
          fetchChannels(res?.data?.list[0]);
          // fetchKeyStakeholders(res?.data?.list[0]?.organisation_id);
        } else if (res?.data?.list?.length === 0) {
          // fetchKeyStakeholders(loggedInUser?.profile?.organisation?.organisation_id);
          fetchChannels(loggedInUser?.profile?.organisation);
        } else {
          setModalOpen(true);
        }
      } else {
        showSnackBar('Unexpected response status or data:', 'error');
      }
    } catch (error) {
      showSnackBar('Failed to fetch organizations:', 'error');

    }
  };

  useEffect(() => {
    // if (channelList?.length === 1) {
    //   handleSelectBot(channelList[0]);
    // }
    if (templateName && botNumber) {
      setIsEditMode(true);
      setModalOpen(false);
      getTemplateData();
    } else {
      fetchOrganisations(organisationFilter);
      resetButtons();
    resetForm();
    resetErrors();
      // setModalOpen(true);
    }
  }, []);

  const getHeaderType = (type) => {
    let header = formData?.components?.find((component) => component?.type === 'HEADER')?.format;
    if (header) {
      return type === header;
    } else {
      return header;
    }
  };

  const getHeaderText = () => {
    let headerObj = formData?.components?.find((component) => component?.type === 'HEADER');
    if (headerObj) return headerObj?.text || '';
    else '';
  };

  const onSelectHeaderType = (obj) => {
    let isHeaderObj = formData?.components?.find((component) => component?.type === 'HEADER');
    if (isHeaderObj) {
      setFormData({
        ...formData,
        components: formData.components.map((component) =>
          component.type === 'HEADER' ? { ...component, format: obj?.value } : component
        ),
      });
    }
    else {
      let components = [...formData?.components];
      let data = { type: 'HEADER', format: obj?.value };
      setFormData({ ...formData, components: [...components, data] });
    }
  };

  const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
    if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
    if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
    if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
    if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
    return null;
  };
  const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);


  const onFileSelect = async (e) => {
    // const selectedFile = e?.target?.files[0];

    // if (!selectedFile) return;

    // const allowedExtensions = ['pdf', 'xls', 'xlsx', 'doc', 'docx'];
    // const disallowedExtensions = ['exe', 'bat', 'sh', 'js', 'msi', 'cmd', 'com', 'scr'];

    // const fileName = selectedFile.name.toLowerCase();
    // const fileExtension = fileName.split('.').pop();

    // if (disallowedExtensions.includes(fileExtension)) {
    //   showSnackBar('This file type is not allowed for upload due to security risks.', 'error');
    //   return;
    // }

    // if (!allowedExtensions.includes(fileExtension)) {
    //   showSnackBar('Only PDF, Excel, and Word files are allowed.', 'error');
    //   return;
    // }

    // console.log('Selected File:', selectedFile);
    // setFile(selectedFile);

    const file = e.target.files?.[0];
    if (!file) return;
    const fileName = file?.name?.toLowerCase();
    const ext = fileName.split('.').pop();
    // 1) Block disallowed / risky extensions
    // const ext = getExt(file.name);
    if (BLOCKED_EXTENSIONS.has(ext)) {
      showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
      // e.currentTarget.value = ''; // reset input
      return;
    }

    // 2) Validate MIME (must match our allowed lists)
    const typeGroup = inferDocType(file.type);
    if (!typeGroup) {
      showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
      // e.currentTarget.value = '';
      return;
    }

    // 3) Enforce WhatsApp limits per media group
    const limit = WHATSAPP_LIMITS[typeGroup];
    if (file.size > limit) {
      showSnackBar(
        `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file.size)} MB.`,
        'error'
      );
      // e.currentTarget.value = '';
      return;
    }

    setFile(file);
  };

  const handleChangeBodyData = (text) => {
    const variableRegex = /\{\{\d+\}\}/g;
    const matches = text.match(variableRegex) || [];
    const variables = matches?.map((match, index) => `{{${index + 1}}}`);
    let newText = text;
    matches.forEach((match, index) => {
      newText = newText?.replace(match, `{{${index + 1}}}`);
    });

    let bodyComponent = formData?.components?.find((component) => component?.type === 'BODY');
    if (!bodyComponent) {
      bodyComponent = { type: 'BODY', text: '' };
      formData.components.push(bodyComponent);
    }

    const updatedVariables = variables.map((_, index) => bodyComponent?.example?.body_text[0][index] || '');

    let parameters = [...formData?.param] || [];

    if (updatedVariables.length > 0) {
      while (parameters.length < variables.length) {
        parameters = [...parameters, ""];
      }
      if (parameters.length > variables.length)
        parameters = parameters.splice(parameters.length - variables.length - parameters.length, variables.length - parameters.length);

      bodyComponent = { ...bodyComponent, text: newText, example: { body_text: [updatedVariables] } };
    } else {
      bodyComponent = { ...bodyComponent, text: newText };
    }

    setFormData({
      ...formData,
      param: parameters,
      components: formData.components.map((component) =>
        component.type === 'BODY' ? bodyComponent : component
      ),
    });
  };
  const addBodyVariables = () => {
    const cursorPosition = textareaRef.current.selectionStart;
    let bodyObj = formData?.components?.find((component) => component?.type === 'BODY');
    let bodyText = bodyObj?.text || '';
    const variableCount = bodyObj?.example?.body_text?.[0]?.length || 0;
    const newVariable = `{{${variableCount + 1}}}`;

    const newText =
      bodyText.slice(0, cursorPosition) +
      newVariable +
      bodyText.slice(cursorPosition);

    handleChangeBodyData(newText);

    // Set cursor position after adding the variable
    setTimeout(() => {
      textareaRef.current.selectionStart = cursorPosition + newVariable.length;
      textareaRef.current.selectionEnd = cursorPosition + newVariable.length;
    }, 0);
  };

  const removeBodyVariables = (i) => {
    let bodyObj = formData?.components?.find((component) => component?.type === 'BODY');
    let bodyVarArr = bodyObj?.example?.body_text[0];
    let filteredVarArr = bodyVarArr.filter((x, index) => index !== i);
    let newBodyVarArr = [filteredVarArr];
    let bodyText = bodyObj.text.replace(`{{${i + 1}}}`, '');
    bodyObj = {
      ...bodyObj,
      text: bodyText,
      example: { ...bodyObj?.example, body_text: newBodyVarArr },
    };
    if (filteredVarArr?.length === 0) {
      delete bodyObj.example;
    }
    setFormData({
      ...formData,
      param: newBodyVarArr[0] || [],
      components: formData?.components?.map((component) =>
        component.type === 'BODY' ? bodyObj : component
      ),
    });
  };

  const handleChangeBodyVariables = (e, index) => {
    let bodyObj = formData?.components?.find((component) => component?.type === 'BODY');
    let bodyVarArr = [...bodyObj?.example?.body_text[0]];
    bodyVarArr[index] = e?.target?.value;
    let newBodyVarArr = [bodyVarArr];
    bodyObj = { ...bodyObj, example: { ...bodyObj?.example, body_text: newBodyVarArr } };
    setFormData({
      ...formData,
      components: formData?.components?.map((component) =>
        component.type === 'BODY' ? bodyObj : component
      ),
    });
  };

  const handleChangeBodyParams = (e, index) => {
    let params = [...formData?.param];
    params[index] = e?.target?.value;
    setFormData({ ...formData, param: params });
  }

  const handleChangeFooterData = (text) => {
    let footerObj = formData?.components?.find((component) => component?.type === 'FOOTER');
    if (footerObj)
      setFormData({
        ...formData,
        components: formData?.components?.map((component) =>
          component.type === 'FOOTER' ? { ...component, text: text } : component
        ),
      });
    else {
      let components = [...formData?.components];
      let obj = { type: 'FOOTER', text: text };
      setFormData({ ...formData, components: [...components, obj] });
    }
  };

  const saveTemplateData = async (e) => {
    setLoading(true);
    let headerObjIndex = formData?.components?.findIndex((component) => component?.type === 'HEADER');
    let templateDataToSubmit = { ...formData, keyStakeholders: keyStakeholders.map((stakeholder) => stakeholder.value) };

    if (!filterObj?.botNumber) {
      showSnackBar('Please select bot number', 'error');
      setLoading(false);
      return 0;
    }
    try {
      if (validateForm()) {
        if (headerObjIndex != -1 && formData?.components[headerObjIndex]?.format !== "TEXT" && file) {
          let headerFileFormData = new FormData();
          // headerFileFormData.append('uploaded_file', file);
          headerFileFormData.append('file', file);
          // headerFileFormData.append('filename', file?.name ?? '');
          // headerFileFormData.append('bot_number', filterObj?.botNumber);

          // Replace the uploadHeaderFile with uploadMediaToWhatsapp
          // let fileResponse = await flowBuilderActions.uploadMediaToWhatsapp(headerFileFormData);
          let fileResponse = await actions.uploadHeaderFile(headerFileFormData, filterObj);
          if (fileResponse?.status === 200) {
            let sessionId = fileResponse?.data?.data?.id;
            let media = { header: fileResponse?.data?.data?.s3_object?.url ?? '' };
            let objectToAdd = {
              "header_handle": [sessionId]
            };
            let components = [...formData?.components];
            components[headerObjIndex] = { ...components[headerObjIndex], example: objectToAdd };
            delete components[headerObjIndex]?.text;
            setFormData({ ...formData, components: components });
            templateDataToSubmit = { ...formData, components: components, media };
          } else {
            showSnackBar('Error when uploading the header file', 'error');
            setLoading(false);
            return 0;
          }
        }

        if (!isEditMode) {

          let res = await actions.postWhatsappTemplate(templateDataToSubmit, filterObj);
          if (res?.status === 200) {
            showSnackBar('Template Created Successfully', 'success');
            resetTableState();
            setTimeout(() => {
              navigate(-1);
            }, 10);
          } else {
            if (res?.data?.data?.general_error?.error?.error_user_msg)
              showSnackBar(`${res?.data?.data?.general_error?.error?.error_user_msg}`, 'error');
            else showSnackBar('Failed to Create Template', 'error');
          }
        } else {
          let res = await actions.updateWhatsappTemplate(templateDataToSubmit, filterObj);
          if (res?.status === 200) {
            showSnackBar('Template Updated Successfully', 'success');
            resetTableState();
            setTimeout(() => {
              navigate(-1);
            }, 10);
          } else {
            if (res?.data?.data?.general_error?.error?.error_user_msg)
              showSnackBar(`${res?.data?.data?.general_error?.error?.error_user_msg}`, 'error');
            else
              showSnackBar('Failed to Update Template', 'error');
          }
        }
      }
    } catch (error) {
      showSnackBar('Failed to Create Template', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', p: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item sx={{ mb: 1 }}>
          <Typography variant="h4" fontWeight="bold">
            {isEditMode ? `Edit ${templateName}` : 'Create Template'}
          </Typography>
        </Grid>
        <Grid item>
          <BackButton onClick={() => navigation(`/r/whatsapp/template-list`)} />
        </Grid>
      </Grid>
      <Divider sx={{ margin: '10px', color: '#333' }} />
      {filterObj?.botNumberObj?.app_name && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            width: '100%',
            backgroundColor: '#f9f9f9',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            mb: 2
          }}
        >
          <Typography
            component="span"
            variant="h6"
            sx={{ fontWeight: 'bold', color: '#333' }}
          >
            {`${filterObj?.botNumberObj?.app_name} (${filterObj?.botNumberObj?.wa_phone_number})`}
          </Typography>
          <IconButton
            onClick={() => { setModalOpen(true); setIsEditModeModal(true) }}
            disabled={isEditMode || editIconEnable}
            color="primary"
            size="medium"
            sx={{
              backgroundColor: '#e3f2fd',
              '&:hover': { backgroundColor: '#bbdefb' },
            }}
          >
            <EditIcon />
          </IconButton>
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8} md={8}>
          <Box>
            {/* Category Form Group */}
            <FormControl component="fieldset" fullWidth>
              <Typography variant="body1">
                Category <span style={{ color: 'red' }}>*</span>
              </Typography>
              <RadioGroup
                aria-label="category"
                name="categoryGroup"
                value={formData?.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                row // This makes the radio buttons inline
              >
                {CategoryOptions.map((obj, index) => (
                  <FormControlLabel
                    key={index}
                    value={obj?.value}
                    control={<Radio disabled={isEditMode} />}
                    label={obj?.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ mt: 2 }}>
            <TextField
              id="name"
              label={<Typography variant="body1">
                Template name <span style={{ color: 'red' }}>*</span>
              </Typography>}
              variant="outlined"
              size='small'
              fullWidth
              value={formData?.name || ''}
              maxLength={512}
              onChange={(e) => {
                handleChangeName(e);
                setFormErrors({ ...formErrors, name: '' });
              }}
              error={!!formErrors?.name}
              helperText={
                <>
                  {formData?.name?.length || 0}/512 characters
                  {formErrors?.name && <span>{formErrors?.name}</span>}
                </>
              }
              // sx={{ height: '50px', width: '200px', fontSize: '12px' }}
              disabled={isEditMode}
            />
          </Box>
          <Box sx={{ mt: 2 }}>

            <TextField
              id="description"
              label="Description (Optional)"
              variant="outlined"
              value={formData?.description || ''}
              onChange={handleChangeDescription}
              multiline
              fullWidth
              rows={2} // You can adjust the number of rows as needed
            // sx={{ width: '200px', fontSize: '12px' }}
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            <SearchableDropdown
              label={<Typography variant="body1">Language <span style={{ color: 'red' }}>*</span></Typography>}
              options={LanguageList}
              onChange={(selectedValue) => {
                if (selectedValue && selectedValue.value) {
                  setFormData({ ...formData, language: selectedValue.value });
                  setFormErrors({ ...formErrors, language: '' });
                } else {
                  setFormData({ ...formData, language: '' });
                  setFormErrors({ ...formErrors, language: '' });
                }
              }}


              value={LanguageList?.find((obj) => obj.value === formData?.language) || null}
              error={formErrors?.language ?? ''}
              errorMessage={formErrors?.language ?? ''}
              disabled={isEditMode}  // Ensure edit mode properly disables dropdown
            />

          </Box>

          <Box sx={{ mt: 2 }}>
            <FormControl component="fieldset" fullWidth error={!!formErrors?.['headerText']}>
              <Typography variant="body1" component="div">
                Header
                <Typography variant="body2" color="textSecondary" component="span" sx={{ ml: 1 }}>
                  (Optional)
                </Typography>
              </Typography>
              <RadioGroup
                aria-label="headerGroup"
                name="headerGroup"
                value={HeaderOptions?.find(option => getHeaderType(option.value))?.value || ''}
                onChange={(e) => {
                  const selectedOption = HeaderOptions?.find(option => option.value === e.target.value);
                  onSelectHeaderType(selectedOption);
                }}
                sx={{ flexDirection: 'row' }}
              >
                {HeaderOptions?.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    value={item?.value}
                    control={<Radio />}
                    label={item?.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            {(getHeaderType('IMAGE') || getHeaderType('VIDEO') || getHeaderType('DOCUMENT') || getHeaderType('TEXT')) && (
              <FormControl fullWidth>
                {getHeaderType('TEXT') ? (
                  <Box>
                    <TextField
                      label="Write here ...."
                      variant="outlined"
                      value={getHeaderText() || ''}
                      size='small'
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          components: formData?.components?.map((component) =>
                            component.type === 'HEADER'
                              ? { ...component, text: e?.target?.value }
                              : component
                          ),
                        });
                        setFormErrors({ ...formErrors, headerText: '' });
                      }}
                      fullWidth
                      error={!!formErrors?.['headerText']}
                      helperText={formErrors?.['headerText'] && <ErrorWrapper error={formErrors?.['headerText']} />}
                    // sx={{ width: '200px', fontSize: '12px' }}
                    />
                  </Box>
                ) : (getHeaderType('IMAGE') || getHeaderType('VIDEO') || getHeaderType('DOCUMENT')) && (
                  <Box sx={{ mt: 2 }}>
                    <FileInput
                      onFileSelect={onFileSelect}
                      onFileRemove={onFileRemove}
                      file={file}
                      setFile={setFile}
                      accept={
                        getHeaderType('IMAGE')
                          ? "image/jpeg,image/png"
                          : getHeaderType('VIDEO')
                            ? "video/mp4,video/3gpp"
                            : '.pdf,.doc,.docx,.xls,.xlsx'
                      }
                    />
                    {/* <Typography variant="body2" color="textSecondary">
                      {`Choose ${getHeaderType('IMAGE') ? 'Image' : getHeaderType('VIDEO') ? 'Video' : 'Document'}`}
                    </Typography> */}
                    <FormHelperText sx={{ mt: 1 }}>
                      {getHeaderType('IMAGE') && "Allowed: JPG, PNG • Max 5 MB"}
                      {getHeaderType('VIDEO') && "Allowed: MP4, 3GP • Max 16 MB"}
                      {getHeaderType('DOCUMENT') && "Allowed: PDF, DOC, DOCX, XLS, XLSX, TXT • Max 100 MB"}
                    </FormHelperText>

                  </Box>
                )}
              </FormControl>
            )}
          </Box>
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth error={!!formErrors?.body}>
              <TextField
                label={<Typography variant="body1" component="div">
                  Body<span style={{ color: 'red' }}>*</span>
                </Typography>}
                inputRef={textareaRef}
                multiline
                fullWidth
                rows={3}
                maxLength={1024}
                placeholder="Write here.."
                value={
                  formData?.components?.find((component) => component?.type === 'BODY')?.text || ''
                }
                onChange={(e) => {
                  handleChangeBodyData(e?.target?.value);
                  setFormErrors({ ...formErrors, body: '' });
                }}
                error={!!formErrors?.body}
                helperText={
                  <>
                    {formData?.components?.find((component) => component?.type === 'BODY')?.text?.length || 0}
                    /1204 characters
                    {formErrors?.body && <span>{formErrors?.body}</span>}
                  </>
                }
              />
            </FormControl>

            <Button
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => {
                addBodyVariables();
              }}
              size='small'
            >
              Add Variables
            </Button>

            {/* If Body example text is available, render the body variables */}
            {formData?.components?.find((component) => component?.type === 'BODY')?.example?.body_text[0]?.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body1" component="div">
                  Body Variables
                </Typography>
                <Box sx={{ mt: 2 }}>
                  {formData?.components
                    ?.find((component) => component?.type === 'BODY')
                    ?.example?.body_text[0]?.map((item, index) => {
                      return (
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }} key={index}>
                          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                            <FormLabel>{`{{${index + 1}}}`}</FormLabel>
                            <TextField
                              variant="outlined"
                              label={`Enter Params ${index + 1}`}
                              value={item || ''}
                              onChange={(e) => {
                                handleChangeBodyVariables(e, index);
                              }}
                              error={!!formErrors?.[`bodyVariable_${index}`]}
                              helperText={formErrors?.[`bodyVariable_${index}`] && <span>{formErrors?.[`bodyVariable_${index}`]}</span>}
                              fullWidth
                              size='small'
                              sx={{ ml: 2 }}
                            />
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                            <TextField
                              variant="outlined"
                              label={`Enter Example ${index + 1}`}
                              value={formData?.param[index] || ''}
                              onChange={(e) => {
                                handleChangeBodyParams(e, index);
                              }}
                              error={!!formErrors?.[`bodyParams_${index}`]}
                              helperText={formErrors?.[`bodyParams_${index}`] && <span>{formErrors?.[`bodyParams_${index}`]}</span>}
                              fullWidth
                              size='small'
                              sx={{ ml: 2 }}
                            />
                          </Box>
                          {/* Remove Button for the last variable */}
                          {formData?.components?.find((component) => component?.type === 'BODY')
                            ?.example?.body_text[0].length - 1 === index && (
                              <IconButton
                                onClick={() => removeBodyVariables(index)}
                                sx={{ color: 'red' }}
                              >
                                <CloseIcon />
                              </IconButton>
                            )}
                        </Box>
                      );
                    })}
                </Box>
              </Box>
            )}
          </Box>
          <Box sx={{ mt: 2 }}>

            <TextField
              fullWidth
              type="text"
              label={<Typography variant="body1" component="div">
                Footer
                <Typography variant="body1" color="textSecondary" component="span" sx={{ ml: 1 }}>
                  (Optional)
                </Typography>
              </Typography>}
              variant="outlined"
              multiline
              rows={2}
              value={
                formData?.components?.find((component) => component?.type === 'FOOTER')?.text || ''
              } onChange={(e) => handleChangeFooterData(e?.target?.value)}
              inputProps={{
                maxLength: 50
              }}
            />
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              {formData?.components?.find((component) => component?.type === 'FOOTER')?.text
                ?.length || 0}
              /{50} characters
            </Typography>
          </Box>
          <Box sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData?.is_calling || false}
                  onChange={(e) => {
                    setFormData({ ...formData, is_calling: e.target.checked });
                  }}
                  name="is_calling"
                  color="primary"
                />
              }
              label="Is Calling"
            />

            {formData?.is_calling && (
              <Box sx={{ mt: 1 }}>
                <TextField
                  id="lead_list_id"
                  label="Lead List id"
                  variant="outlined"
                  value={formData?.lead_list_id || ''}
                  onChange={(e) => {
                    setFormData({ ...formData, lead_list_id: e.target.value });
                  }}
                  maxLength={50}
                  fullWidth
                  size='small'
                />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <MessagePreview />
        </Grid>
      </Grid>
      <ButtonInputs />
      <Box sx={{ mt: 2 }}>
        <Button
          loading={loading}
          onClick={saveTemplateData}
          variant="contained"
          disabled={loading}
          fullWidth
          size='small'
          sx={{ width: '50px' }}
        >
          Save
        </Button>
      </Box>
      {
        isModalOpen &&
        <OrganisationBotSelectionModal open={isModalOpen} onClose={handleCloseModal} isEdit={isEditModeModal}
          selectedOrganisation={filterObj?.organisationObj || null}
          selectedBot={filterObj?.botNumberObj || null} />
      }
    </Box>
  );
}

export default CreateTemplates;
